module.exports = __webpack_public_path__ + "static/media/Rainstorm.4c063dd1.webp";